@if (vm.content) {
<div class="row">
   <div class="col-xs-12">
      <div class="accordion application-form">
         <div class="opener">
            <span class="num last"
               >1 <sup>a</sup>
               <i class="fa fa-check" aria-hidden="true"></i
            ></span>
            <h1>{{ vm.content.title }} - {{ vm.content.step1ConfirmTitle }}</h1>
            <p [innerHtml]="vm.content.step1Question"></p>
         </div>
         <div class="slide">
            <form action="#">
               <fieldset>
                  <legend class="sr-only">{{ vm.content.step1ConfirmSubTitle }}</legend>
                  <div class="section">
                     <div class="row section__heading">
                        <div class="col-sm-6">
                           <h2>{{ vm.content.step1ConfirmSubTitle }}</h2>
                        </div>
                     </div>
                     <div class="form-group">
                        <label for="step1Question">{{ vm.content.step1Question }}</label>
                     </div>

                     <div class="form-group">
                        <strong>
                           <address class="address" data-hj-suppress>
                              <span data-hj-suppress>{{ vm.tenancy.addressLine1 }}</span>
                              <span data-hj-suppress>{{ vm.tenancy.addressLine2 }}</span>
                              <span data-hj-suppress>{{ vm.tenancy.addressLine3 }}</span>
                              <span data-hj-suppress>{{ vm.tenancy.postcode }}</span>
                           </address>
                        </strong>
                     </div>
                  </div>
                  <div class="section">
                     <app-identification-error-summary></app-identification-error-summary>
                     <div class="btn-set clearfix">
                        @if (vm.tenancy.allowPortalRegistration) {
                        <button
                           type="button"
                           (click)="confirmAddress()"
                           id="idvStep1ConfirmContinueButton"
                           class="btn btn-primary btn-send"
                        >
                           {{ vm.content.step1ConfirmMyAddressButton }}
                        </button>
                        } @else {
                        <button
                           type="button"
                           (click)="confirmAddress()"
                           id="idvStep1ConfirmPortalNotAllowedButton"
                           class="btn btn-primary btn-send"
                        >
                           {{ vm.content.step1ConfirmContinueButton }}
                        </button>
                        }
                        <button type="button" (click)="changeDetails()" id="idvStep1ConfirmReenterDetailsButton" class="btn btn-default">
                           {{ vm.content.step1ConfirmBackButton }}
                        </button>
                        <button type="button" (click)="notMyAddress()" id="idvStep1ConfirmNotMyAddressButton" class="btn btn-default">
                           {{ vm.content.step1ConfirmProblemButton }}
                        </button>
                     </div>
                  </div>
               </fieldset>
            </form>
         </div>
      </div>
   </div>
</div>
}
